import React, { useReducer, useEffect, useContext } from "react"
import { SessionService } from "../services/SessionService";
import { Action } from "../models/Action";
import { EventEmitterService, EventKey } from "../services/EventEmitterService";
import StorageService from "../services/StorageService";
import { awaitWithLoading,isToday } from "../services/utils";
import { PaymentMethod } from "../models/user-models/CreditCardModal";
import coveragesApi from '../api/coverages.api'
import { PolicyManagementContextStore } from "./PolicyManagementContext";
import { useParams } from "react-router-dom";
import { InsuranceStatus } from '../models/insurance-models/InsuranceStatus';
import { SessionContextStore } from "./SessionContext";


export const POLICY_MODIFICATION_CONTEXT_ACTIONS = {
    LOAD_COVERAGE_OPTIONS: 'LOAD_COVERAGE_OPTIONS',
    SET_IS_CERTIFICATION_VALID: 'SET_IS_CERTIFICATION_VALID'
}

export const ONGOING_PURCHASE = 'purchase_ongoing';


const defaultSubscriptioInsurance = {
    insuranceChanged:false,
    insuranceId: "",
    liabilityLimitOptions:[],
    bodilyInjuryLiabilityOptions:[],
    medicalPaymentsOptions:[],
    deductibleReimbursementOptions:[],
    liabilityLimit: 0,
    bodilyInjuryLiabilityLimit:0,
    liabilityLimitPremium:0,
    price: 0,
    commercial: false,
    priceWithTaxes: 1,
    totalDiscount: 1,
    dronePremium: 1,
    equipmentPremium: 1,
    billingPeriod: "Year",
    medicalExpenseLimitPremium: 0,
    personalInjuryLimitpremium: 0,
    namedInsured: null,
    additionalInsuredList:[],
    stripeCustomerId: null,
    isEditNamedInsured: false,
    isEditHours:false
} 


const defaultState = {
    liabilityLimitOptions:[],
    bodilyInjuryLiabilityOptions:[],
    medicalPaymentsOptions:[],
    deductibleReimbursementOptions:[],
    selectedLiability:{
        liability:'',
        bodilyInjury:'',
        medicalPayments:''
    },
    offer:{offerId:''},
    isEditNamedInsured: false,
    insuranceId:"",
    price:0,
    insurance:  defaultSubscriptioInsurance,
    subscription:  defaultSubscriptioInsurance,
    externalUserId: '',
    nextPolicyDate: new Date(),
    startPolicyDate:new Date(),
    additionalInsuredList: [],
    autoRenew: true, 
    equipmentTypes: [],
    paymentMethod: PaymentMethod.STRIPE,
    allAdditionalInsuredList: [],
    isLiabilityValid: true,
    isHullSectionValid: true,
    isAddionalCoverageValid: true,
    isCertificationValid:true,
    setLiabilityLimit: (option,isRenewal) => { "Not Implemented"},
    setBodilyInjuryLiabilityLimit: (option, isRenewal) => { "Not Implemented"},
    dispatch: (action: Action) => {"Not Implemented"},
}

const reducer = (state, action: Action) => {
    console.log('ModificationContext state', state, action)
    
    const newStateCalculate = () => {
        switch (action.type) {
            case 'RESET':
                return {...state, drones: [], equipment: [], autoRenew: true, additionalInsuredList: []}
            case 'SET_SUBSCRIPTION_DATA':
                return {...state ,subscription:action.data}
            case 'SET_INSURANCE_DATA':
                return {...state ,insurance:action.data}
            case POLICY_MODIFICATION_CONTEXT_ACTIONS.LOAD_COVERAGE_OPTIONS:
                return {...state,...state.insurance ,liabilityLimitOptions: action.data.aircraft_damage_liability ,bodilyInjuryLiabilityOptions: action.data.bodily_injury_liability}
            case 'UPDATE_OFFER':
                return {...state,insurance:{...state.insurance, offer:action.data}}
            case 'UPDATE_SUBSCRIPTION_OFFER':
                return {...state,subscription:{...state.subscription, offer:action.data}}
            case 'UPDATE_PRICE':
                return {...state, insurance:{...state.insurance, price:action.data}}
            case 'CHANGE_MEDICAL_EXPENSE_LIMIT_SUBSCRIPTION':
                return {...state , subscription: {...state.subscription, medicalExpenseLimit: action.data }}
            case 'CHANGE_MEDICAL_EXPENSE_LIMIT_INSURANCE':
                return {...state , insurance: {...state.insurance,insuranceChanged:true, medicalExpenseLimit: action.data }}
            case 'CHANGE_LIABILIY_LIMIT_SUBSCRIPTION':
                return {...state , subscription: {...state.subscription,insuranceChanged:true, selectedLiability:{...state.subscription.selectedLiability,liability:action.data}}}
            case 'CHANGE_LIABILIY_LIMIT_INSURANCE':
                return {...state , insurance: {...state.insurance,insuranceChanged:true, selectedLiability:{...state.insurance.selectedLiability,liability:action.data}}}
            case 'CHANGE_PERSONAL_INJURY_LIMIT_SUBSCRIPTION':
                return {...state , subscription: {...state.subscription,insuranceChanged:true, selectedLiability:{...state.subscription.selectedLiability,bodilyInjury:action.data}}}
            case 'CHANGE_BODILY_INJURY_LIABILITY_LIMIT_INSURANCE':
                return {...state , insurance: {...state.insurance,insuranceChanged:true, selectedLiability:{...state.insurance.selectedLiability,bodilyInjury:action.data}}}
            case 'CHANGE_NUMBER_OF_DRONES_OPERATE_SUBSCRIPTION':
                return {...state , subscription: {...state.subscription, numberOfDronesOperate: action.data}}
            case 'CHANGE_NUMBER_OF_DRONES_OPERATE_INSURANCE':
                return {...state , insurance: {...state.insurance, numberOfDronesOperate: action.data}}
            case 'LOAD_INSURANCE_MODIFY_PRICE':
                return {...state ,insurance:{...state.insurance , price: action.data }}
            case 'LOAD_SUBSCRIPTION_MODIFY_PRICE':
                return {...state ,subscription:{...state.subscription , price: action.data}}
            case 'ADD_DRONE_SUBSCRIPTION':
                return {...state, subscription: {...state.subscription ,drones: [...state.subscription.drones, action.data]}}
            case 'ADD_DRONE_INSURANCE':
                return {...state, insurance: {...state.insurance ,insuranceChanged:true,drones: [...state.insurance.drones, action.data]}}
            case 'ADD_EQUIPMENT_SUBSCRIPTION':
                return {...state, subscription: {...state.subscription ,equipment: [...state.subscription.equipment ,action.data]}}
            case 'ADD_EQUIPMENT_INSURANCE':
                return {...state, insurance: {...state.insurance ,insuranceChanged:true,equipment: [...state.insurance.equipment ,action.data]}}
            case 'DELETE_DRONE_SUBSCRIPTION':
                return {...state, subscription :{...state.subscription, drones: state.subscription.drones.filter((item, index) => index != action.data)}}
            case 'DELETE_DRONE_INSURANCE':
                return {...state, insurance :{...state.insurance,insuranceChanged:true, drones: state.insurance.drones.filter((item, index) => index != action.data)}}
            case 'DELETE_EQUIPMENT_SUBSCRIPTION':
                return {...state, subscription :{...state.subscription, equipment: state.subscription.equipment.filter((item, index) => index != action.data)}}
            case 'DELETE_EQUIPMENT_INSURANCE':
                return {...state, insurance :{...state.insurance,insuranceChanged:true, equipment: state.insurance.equipment.filter((item, index) => index != action.data)}}
            case 'EDIT_INSURED_SUBSCRIPTION':
                return {...state, subscription: { ...state.subscription, namedInsured: action.data }, isEditNamedInsured: false,isEditHours:false}
            case 'EDIT_INSURED_INSURANCE':
                return {...state, insurance: { ...state.insurance, namedInsured: action.data, insuranceChanged: true }, isEditNamedInsured: false}
            case 'EQUIPMENT_TYPES_LOADED':
                return {...state, equipmentTypes: [...action.data]}
            case 'CHANGE_SUBSCRIPTION_TOTAL_HOURS_LOGGED':
                return {...state, subscription: {...state.subscription, insuredPerson:{...state.subscription.insuredPerson,totalHoursLogged: action.data.totalHoursLogged,totalHoursMultiEngineLogged: action.data.totalHoursMultiEngineLogged,totalHoursFloatsLogged: action.data.totalHoursFloatsLogged }, isEditHours:false}}
            case 'CHANGE_SUBSCRIPTION_PILOT_CERTIFICATION':{
                return {...state,subscription:{...state.subscription,insuredPerson:{...state.subscription.insuredPerson , pilotCertification:action.data.pilotCertification}}}
            }
            case 'CHANGE_SUBSCRIPTION_PILOT_RATING':{
                return {...state,subscription:{...state.subscription,insuredPerson:{...state.subscription.insuredPerson , pilotTraining:action.data.pilotRating}}}
            }
            case POLICY_MODIFICATION_CONTEXT_ACTIONS.SET_IS_CERTIFICATION_VALID:
                return {...state, isCertificationValid: action.data }
            case 'EDIT_INSURED':
                return {...state, isEditNamedInsured: true }
            case 'EDIT_HOURS':
                return {...state, subscription:{...state.subscription,isEditHours:true} }
          default: 
            return state;
        }
    }
     
    const newState = newStateCalculate()

    return newState
};


export const ModificationContextStore = React.createContext(defaultState)
ModificationContextStore.displayName = 'ModificationContext'

const ModificationContext = (props) => {
    const policyManagementContext = useContext(PolicyManagementContextStore)
    const {user: {commercial}, setUserCommercial} = useContext(SessionContextStore)
    const { insuranceId } = useParams()
    const insurance = policyManagementContext.active_policies.find(item => item.insuranceId == insuranceId) || policyManagementContext.scheduled_policies.find(item => item.insuranceId == insuranceId);
    const isActive = () => {
        return insurance.getStatus() != InsuranceStatus.CANCELED && insurance.getStatus() != InsuranceStatus.EXPIRED
    }
    const loadLiabilityExtensionOffers = async (id) => {
        
        const loadFormOptions = async () => {
            
            let res = await awaitWithLoading(coveragesApi.loadOptions(insuranceId));
            if (res.ok) {
                let parsedOptions = {};
                Object.keys(res.data).map((name) => {
                    
                    parsedOptions[name] = res.data[name].map((item) => {
                    if (item.breakdown && item.breakdown.length > 1)
                        return {
                        labels: item.breakdown.map((k) => k.label),
                        values: item.breakdown.map((k) => k.sublabel),
                        value: item.value,
                        tooltip: item.tooltip,
                        };
                    // else if (item.breakdown)
                    //     return {
                    //     label: item.breakdown[0].sublabel,
                    //     value: item.value,
                    //     tooltip: item.tooltip,
                    //     };
                    else {
                        return {
                        label: item.subtitle,
                        value: item.value,
                        tooltip: item.tooltip,
                        };
                    }
                    });
                });
                
                dispatch({ type: POLICY_MODIFICATION_CONTEXT_ACTIONS.LOAD_COVERAGE_OPTIONS, data: parsedOptions });
                } else {
                EventEmitterService.dispatch(EventKey.ShowError, res);
                }
            };
    loadFormOptions()
    }
    const getPolicyDetails = async () => {
        
        const activeSubscription = insurance.subscription
        const vehicle = insurance.insuredVehicles[0]
            await loadLiabilityExtensionOffers(insurance.insuranceId)
            dispatch(new Action('SET_INSURANCE_DATA',
            {
                commercial: commercial,
                insuranceChanged:false,
                id: insurance.insuranceId,
                selectedLiability:{
                    liability:insurance.policyCoverages.aircraftDamageLiability.liability,
                    bodilyInjury:insurance.policyCoverages.bodilyInjuryLiability.liability,
                    medicalPayments:insurance.policyCoverages.medicalPayments.liability,
                    deductibleReimbursement:insurance.policyCoverages.deductibleReimbursement.liability
                },
                offer:{
                    offerId:'',
                    liability:insurance.policyCoverages.aircraftDamageLiability,
                    bodilyInjury:insurance.policyCoverages.bodilyInjuryLiability,
                    medicalPayments:insurance.policyCoverages.medicalPayments,
                    deductibleReimbursement:insurance.policyCoverages.deductibleReimbursement
                },
                billingPeriod: insurance.insuranceType,
                medicalExpenseLimitPremium: insurance.policyCoverages.medicalPayments.price,
                bodilyInjuryLimitPremium: insurance.policyCoverages.bodilyInjuryLiability.price,
                liabilityLimitPremium: insurance.policyCoverages.aircraftDamageLiability.price,
                stripeCustomerId: insurance.stripeCustomerId,
                price: 0,
                namedInsured: insurance.namedInsured,
                startPolicyDate:insurance.validFromUtc,
                autoRenew:insurance.autoRenew,
                singleEngineLand:vehicle.singleEngineLand,
                singleEngineSeaplane:vehicle.singleEngineSeaplane,
                multiEngineLand:vehicle.multiEngineLand,
            }))

            let subscription = insurance.subscription
            dispatch(new Action('SET_SUBSCRIPTION_DATA',
            {
                commercial: commercial,
                subscriptionChanged:false,
                id: subscription.subscriptionId,
                selectedLiability:{
                    liability:subscription.policyCoverages.aircraftDamageLiability.liability,
                    bodilyInjury:subscription.policyCoverages.bodilyInjuryLiability.liability,
                    medicalPayments:subscription.policyCoverages.medicalPayments.liability,
                    deductibleReimbursement:subscription.policyCoverages.deductibleReimbursement.liability
                },
                offer:{
                    offerId:'',
                    liability:subscription.policyCoverages.aircraftDamageLiability,
                    bodilyInjury:subscription.policyCoverages.bodilyInjuryLiability,
                    medicalPayments:subscription.policyCoverages.medicalPayments,
                    deductibleReimbursement:subscription.policyCoverages.deductibleReimbursement

                },
                billingPeriod: subscription.billingPeriod,
                medicalExpenseLimitPremium: subscription.policyCoverages.medicalPayments.price,
                bodilyInjuryLimitPremium: subscription.policyCoverages.bodilyInjuryLiability.price,
                liabilityLimitPremium: subscription.policyCoverages.aircraftDamageLiability.price,
                insuredPerson:{
                    ...subscription.insuredPersons[0],
                    pilotCertification: activeSubscription.insuredPersons[0].pilotCertification,
                    pilotTraining: activeSubscription.insuredPersons[0].pilotTraining
                        .split(',')
                        .map((x) => x.trim())
                        .filter((k) => k != 'None'),
                    isStudent: activeSubscription.insuredPersons[0].pilotCertification ==='Student'
                },
                price: subscription.totalPrice,
                namedInsured: subscription.namedInsured,
                startPolicyDate:subscription.billingStartDate,
                autoRenew:insurance.autoRenew,
                nextBillingDate:subscription.nextBillingDate,
                singleEngineLand:vehicle.singleEngineLand,
                singleEngineSeaplane:vehicle.singleEngineSeaplane,
                multiEngineLand:vehicle.multiEngineLand
            }))
    }

    const [state, dispatch] = useReducer(reducer, defaultState, () => {
        let savedState = {}
        return Object.assign({}, defaultState)
    })

    const modify = async (isRenewal) => {
        let res;
        if(isRenewal){
            res = await awaitWithLoading(
            coveragesApi.editRenewal(state.subscription.offer.offerId, insuranceId, state.subscription.namedInsured,state.subscription.insuredPerson))
        }
        else{
            res = await awaitWithLoading(
            coveragesApi.bindMidtermOffer(state.insurance.offer.offerId, insuranceId, state.insurance.namedInsured))
        }        
        if (res.ok) {
            let title = isRenewal ? 'Subscription changed successfully' : 'Midterm changed successfully'
            let body = isRenewal ? 'Your changes have been made.' : 'Your changes have been made. An email will be sent to you with the policy’s updated coverages endorsement.';
            EventEmitterService.dispatch(EventKey.ShowSuccess, {
                title: title,
                body: body,
                onClose: () => {
                    window.location.reload(false)
                },
            })
        } else {
            EventEmitterService.dispatch(EventKey.ShowError, res)
        }
    }


    useEffect(() => {
        if(state.subscription != defaultSubscriptioInsurance && state.insurance.insuranceId != "")
        {
            calcSubscriptionPrices()
        }
    },[state.subscription.selectedLiability,state.subscription.namedInsured, state.subscription.insuredPerson])

    // useEffect(() => {
    //     if(state.subscription != defaultSubscriptioInsurance && state.insurance.insuranceId != "")
    //     {
    //         calcSubscriptionPrices()
    //     }
    // },[state.subscription])
    
    
    useEffect(() => {
        //TODO : ADD HERE IF THERE IS SOMTHING THAT IS NOT VALID 
        if(state.insurance != defaultSubscriptioInsurance && state.insurance.insuranceId != "" && state.insurance.insuranceChanged /* && isValid */)
        {
            calcMidtermPrices()
        }
    },[state.insurance.selectedLiability,state.insurance.namedInsured])

    useEffect(() => {
        if(!!insurance && !!insuranceId)
            getPolicyDetails()

    }, [insurance])

    const calcSubscriptionPrices = async () => {
        if (defaultState == state) return
        let startTime = undefined
        let dateObj = new Date(state.subscription.nextBillingDate)
        if(!(!!dateObj && isToday(dateObj))){
            startTime = new Date(Date.UTC(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate(), 0, 1, 0, 0));
        }

        let offer = Object.assign({}, state.offerCart);
        delete offer.vehicle_requests;
        delete offer.period;
        delete offer.additional_insureds;
        delete offer.additional_insured;
        delete offer.autoRenew;
        if(insuranceId != null){
        var res = await awaitWithLoading(
            coveragesApi.requestOffer({
            total_hours_logged: state.subscription.insuredPerson.totalHoursLogged,
            total_hours_floats_logged: state.subscription.insuredPerson.totalHoursFloatsLogged,
            total_hours_multi_engine_logged: state.subscription.insuredPerson.totalHoursMultiEngineLogged,
            pilot_certification:state.subscription.insuredPerson.pilotCertification,
            pilot_training:state.subscription.insuredPerson.pilotTraining.length > 0
                ? state.subscription.insuredPerson.pilotTraining.join(', ')
                : 'None',
            insurance_id: insuranceId,
            start_time: startTime,
            additional_insured: "",
            coverages:{
                aircraft_damage_liability:state.subscription.selectedLiability.liability,
                bodily_injury_liability: state.subscription.selectedLiability.bodilyInjury,
                medical_payments: state.subscription.selectedLiability.medicalPayments,
                deductible_reimbursement: state.subscription.selectedLiability.deductibleReimbursement
            },
            auto_renew: state.subscription.autoRenew,
            insurance_duration: state.subscription.billingPeriod,
            },true));
        } 
        if(res.ok){
            dispatch({ type: 'UPDATE_SUBSCRIPTION_OFFER', data: {
                offerId:res.data.offerId,
                liability: res.data.vehicleCoveragePrices[Object.keys(res.data.vehicleCoveragePrices)[0]].coveragePrices.aircraftDamageLiability,
                bodilyInjury:res.data.vehicleCoveragePrices[Object.keys(res.data.vehicleCoveragePrices)[0]].coveragePrices.bodilyInjuryLiability,
                medicalPayments:res.data.vehicleCoveragePrices[Object.keys(res.data.vehicleCoveragePrices)[0]].coveragePrices.medicalPayments,
                deductibleReimbursement:res.data.vehicleCoveragePrices[Object.keys(res.data.vehicleCoveragePrices)[0]].coveragePrices.deductibleReimbursement

            }});
            dispatch({ type: 'LOAD_SUBSCRIPTION_MODIFY_PRICE', data:res.data.price});
        }
    }
    const calcMidtermPrices = async () =>{
        if (defaultState == state) return
        let startTime = undefined
        let dateObj = new Date(state.insurance.startPolicyDate)
        if(!(!!dateObj && isToday(dateObj))){
            startTime = new Date(Date.UTC(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate(), 0, 1, 0, 0));
        }

        let offer = Object.assign({}, state.offerCart);
        delete offer.vehicle_requests;
        delete offer.period;
        delete offer.additional_insureds;
        delete offer.additional_insured;
        delete offer.autoRenew;
        
        if(insuranceId != null){
        var res = await awaitWithLoading(
            coveragesApi.requestOffer({
            insurance_id: insuranceId,
            start_time: startTime,
            additional_insured: "",
            coverages:{
                aircraft_damage_liability:state.insurance.selectedLiability.liability,
                bodily_injury_liability: state.insurance.selectedLiability.bodilyInjury,
                medical_payments: state.insurance.selectedLiability.medicalPayments,
                deductible_reimbursement: state.insurance.selectedLiability.deductibleReimbursement

            },
            auto_renew: state.insurance.autoRenew,
            insurance_duration: 'Year',
            //vehicle_requests: state.offerCart.vehicle_requests,
            }));
            //dispatch({ type: 'PRICE_BREAKDOWN_CHANGED', data: res.data });
        } 
        if(res.ok){
            dispatch({ type: 'UPDATE_OFFER', data: {
                offerId:res.data.offerId,
                liability: res.data.vehicleCoveragePrices[Object.keys(res.data.vehicleCoveragePrices)[0]].coveragePrices.aircraftDamageLiability,
                bodilyInjury:res.data.vehicleCoveragePrices[Object.keys(res.data.vehicleCoveragePrices)[0]].coveragePrices.bodilyInjuryLiability,
                medicalPayments:res.data.vehicleCoveragePrices[Object.keys(res.data.vehicleCoveragePrices)[0]].coveragePrices.medicalPayments,
                deductibleReimbursement:res.data.vehicleCoveragePrices[Object.keys(res.data.vehicleCoveragePrices)[0]].coveragePrices.deductibleReimbursement

            }});
        }

        let res2 = await awaitWithLoading(
            coveragesApi.calcMidtermPrice(res.data.offerId, insuranceId)
        )
        if (res2.ok) {
            dispatch({ type: 'LOAD_INSURANCE_MODIFY_PRICE', data:res2.data});
        } else {
            EventEmitterService.dispatch(EventKey.ShowError, res2)
        }
    }

    const setLiabilityLimit = (option,isRenewal) => {
        if(isRenewal)
            dispatch(new Action('CHANGE_LIABILIY_LIMIT_SUBSCRIPTION', option))
        else
        {
            dispatch(new Action('CHANGE_LIABILIY_LIMIT_INSURANCE', option))
        }   
    }

    const setBodilyInjuryLiabilityLimit = (option, isRenewal) => {
        
        if(isRenewal)
            dispatch(new Action('CHANGE_PERSONAL_INJURY_LIMIT_SUBSCRIPTION', option))
        else
            dispatch(new Action('CHANGE_BODILY_INJURY_LIABILITY_LIMIT_INSURANCE', option))
    }


    const saveInsured = (profile, isRenewal) => {
        if(isRenewal)
            dispatch(new Action('EDIT_INSURED_SUBSCRIPTION', profile))
        else 
            dispatch(new Action('EDIT_INSURED_INSURANCE', profile))
    }

    const editInsured = () => {
        dispatch(new Action('EDIT_INSURED'))
    }
    const changeHoursLogged = (option) => {
        let values = {
            totalHoursLogged:Number.parseInt(option.total_hours_logged),
            totalHoursMultiEngineLogged:Number.parseInt(option.total_hours_multi_engine_logged),
            totalHoursFloatsLogged:Number.parseInt(option.total_hours_floats_logged)
        }
        dispatch(new Action('CHANGE_SUBSCRIPTION_TOTAL_HOURS_LOGGED',values))
    }

    const changePilotCertificate = (option) => {
        let value ={
            pilotCertification:option
        }
        dispatch(new Action('CHANGE_SUBSCRIPTION_PILOT_CERTIFICATION',value))
    }
    const changePilotRatings = (option) => {
        let value ={
            pilotRating:option
        }
        dispatch(new Action('CHANGE_SUBSCRIPTION_PILOT_RATING',value))
    }

    const editHours = () => {
        dispatch(new Action('EDIT_HOURS'))
    }


    return (<ModificationContextStore.Provider value={{ ...state, editInsured, saveInsured, dispatch,getPolicyDetails,modify,setLiabilityLimit, setBodilyInjuryLiabilityLimit,changeHoursLogged,editHours,changePilotCertificate,changePilotRatings}}>
            {props.children}
        </ModificationContextStore.Provider>)   
}

export default ModificationContext



